import React, {useState} from 'react'
import Images from "../Assets/Images";
import Professional from "../Components/Professional";
import Personal from "../Components/Personal";

export default function About(){

    const [professional, setProfessional] = useState(true);

    const showContent = (view) => {
        setProfessional(view === "prof");
    };

    return(
        <div id="background" className="bg-stone-300 min-h-screen w-full p-2 lg:p-6">
            <div id="full" className="bg-stone-50 p-3 lg:p-10 rounded-lg w-full shadow-md max-w-6xl mx-auto space-y-4">
                {/* Buttons */}
                <div className="flex flex-wrap justify-center gap-2">
                    <button
                        onClick={() => showContent("prof")}
                        className={`px-6 py-2 font-semibold rounded-lg transition-all duration-300 shadow-sm ${
                            professional
                                ? "bg-gradient-to-r from-[#6C5F5B] to-[#695955FF] text-white shadow-md scale-105"
                                : "bg-[#F7F5F3] text-[#5D514DFF]"

                        }`}
                    >
                        Professional
                    </button>

                    <button
                        onClick={() => showContent("real")}
                        className={`px-6 py-2 font-semibold rounded-lg transition-all duration-300 shadow-sm ${
                            !professional
                                ? "bg-gradient-to-r from-[#6C5F5B] to-[#695955FF] text-white shadow-md scale-105"
                                : "bg-[#F7F5F3] text-[#5D514DFF]"

                        }`}
                    >
                        Personal
                    </button>
                </div>

            <div>
                {professional && (
                    <Professional/>

                )}
                {!professional && (
                    <Personal/>

                )}
            </div>
            </div>
        </div>

    )

}